import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Paths } from "../../router/Paths";
import { useUser } from "../../hooks/useUser";
import OTPInput from "../../components/common/OTPInput";
import { passwordValidate } from "../../utils/validation";

function RecoverPasswordSection() {
  const { resetPassword, resendRecoverOTP } = useUser();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get("email");

  //  states
  const [otp, setOtp] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [passwordOn, setPasswordOn] = useState<boolean>(false);
  const [otpError, setOtpError] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");
  const [recovering, setRecovering] = useState<boolean>(false);
  const [resending, setResending] = useState<boolean>(false);

  useEffect(() => {
    setOtpError("");
    setPasswordError("");
  }, [otp, password]);

  const handleResend = async () => {
    if (resending) return;
    await resendRecoverOTP({ email: email || "", setLoading: setResending });
  };

  const handleSignup = () => {
    navigate(Paths.signup);
  };

  const handleRecover = async () => {
    const invalidPassword = passwordValidate(password);
    if (otp.length !== 6)
      return setOtpError("Please enter the verification code");
    if (invalidPassword) {
      return setPasswordError(invalidPassword);
    }
    await resetPassword({
      setLoading: setRecovering,
      otp: parseInt(otp),
      password,
    });
  };

  return (
    <div className={ClassName.container}>
      <div className="bg-[#F8F8F8] rounded-2xl w-full max-w-[540px] py-6 px-3 lg:px-6 flex flex-col items-center mx-2">
        <span className="text-3xl lg:text-4xl font-bold mb-4">
          Recover password
        </span>
        <span className="text-sm lg:text-base text-[#818083]">
          Please enter the verification code sent to your email
        </span>
        <span className={ClassName.label}>{email}</span>
        <OTPInput
          classname="mt-3 mb-2"
          onChange={(value) => {
            setOtp(value);
          }}
        />
        {otpError && <span className={ClassName.error}>{otpError}</span>}

        <span className={`${ClassName.label} w-full mt-2`}>New password</span>
        <div className={ClassName.input}>
          <input
            type={passwordOn ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-transparent flex flex-1"
          />
          <img
            src={passwordOn ? "/IconEyeOn.svg" : "/IconEyeOff.svg"}
            alt=""
            className="w-5 h-5 object-contain cursor-pointer"
            onClick={() => setPasswordOn(!passwordOn)}
          />
        </div>
        {passwordError && (
          <span className={ClassName.error}>{passwordError}</span>
        )}

        <span
          className={`${ClassName.label} text-primary mt-2 cursor-pointer`}
          onClick={handleResend}
        >
          {" "}
          {resending ? "Please wait... " : "Resend OTP"}
        </span>

        <button
          onClick={handleRecover}
          className="h-12 w-full rounded-lg bg-primary text-white font-bold text-sm lg:text-base mt-4"
        >
          {recovering ? "Please wait ..." : "Recover password"}
        </button>
        <div className="w-full flex flex-col items-center mt-4">
          <span
            className={`${ClassName.label} cursor-pointer mt-0 text-[#B5B5B5]`}
          >
            Don't have an account?
            <span className="text-primary" onClick={handleSignup}>
              {" "}
              Signup
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default RecoverPasswordSection;

const ClassName = {
  container: "w-full h-screen flex items-center justify-center",
  input:
    "border rounded-lg flex flex-1 w-full px-4 py-3 bg-transparent border-[#DBDBDB]",
  error: "text-red-600 text-sm mt-2 mb-2",
  label: "text-[#818083] text-sm lg:text-base font-bold mb-1",
};
